import { VeltComments } from '@veltdev/react';
import { useEffect } from 'react';
import './CommentsTextPage.css';

function CommentsTextPage() {

    useEffect(() => {
        document.querySelector('velt-comments')?.setAttribute('dark', '');
    }, []);

    return (
        <div className='comments-text-container'>
            <VeltComments textMode={true} />
            <p className="boujeeText">Highlight some of this text to leave a comment.</p>
        </div>
    )
}

export default CommentsTextPage;